// @ts-ignore
export const OliviaCrmAppApiUrl = window._env_.OLIVIA_CRM_API_URL;

export const apiUrls = {
    agreements: {
        count: "/agreements/count",
        agreements: "/agreements/",
        agreementsShortData: "/agreements/short_data/",
        agreementsWithBankingShortData: "/agreements/short_data_with_banking/",
        agreementDataForNewContact: (agreementId)=>`agreements/${agreementId}/data_for_new_contact/`,
        agreement: (agreementId) => `/agreements/${agreementId}/`,
        agreementNotificationList: (agreementId) => `/agreements/${agreementId}/notifications`,
        files: (agreementId) => `/agreements/${agreementId}/files`,
        deleteFromAgreement: "/files/agreement/delete/",
        listAgreementDocuments: (agreementId) => `/files/agreement/${agreementId}/list/`,
        paymentSchedules: "/agreements/payment-schedules/",
        paymentSchedule: (id) => `/agreements/payment-schedules/${id}/`,
        kinds: "/agreements/kinds/",
        types: "/agreements/types/",
        payments: "/agreements/payments/",
        payment: (paymentId) => `/agreements/payments/${paymentId}/`,
        milestones: (investmentId) => `/agreements/investments/${investmentId}/payment-milestones/`,
        defaultPaymentSchedule: (investmentId) =>
            `/agreements/payment-schedule/default/${investmentId}/`,
        cancel: (agreementId) => `/agreements/${agreementId}/cancel/`,
        finalSettlement: (agreementId) => `/agreements/${agreementId}/final_settlement/`,
        cancellationReasons: "/agreements/reasons/",
        statuses: "/agreements/statuses/",
        notify: "/agreements/notify/",
        count: "/agreements/count",
        notificationSelectList: "/agreements/notification/select_list",
        agreementOverduePayments: "/agreements/agreement-overdue-payments/",
        agreementOverduePaymentsCount: "/agreements/agreement-overdue-payments/count",
        agreementRescheduledPaymentList: "/agreements/agreement-rescheduled-payment-list/",
        agreementFinancialReport: "/agreements/financial-report/",
    },
    bookings: {
        all: "/bookings/all",
        count: "/bookings/count",
        booking: (bookingId) => `/bookings/${bookingId}/detail/`,
        statuses: "/bookings/statuses/",
        cancellationReasons: "/bookings/reasons/",
        cancel: (bookingId) => `/bookings/${bookingId}/cancel`,
        create: "/bookings/create/",
        update: (bookingId) => `/bookings/${bookingId}/`,
        postponed: "/bookings/rescheduled/all/",
        customer: (customerId) => `/bookings/customer/${customerId}/`,
    },
    customers: {
        all: "/customers/all",
        customershortData: "/customers/all/short_data/",
        customerApprovedClauses: "/customers/all/approve_clauses/",
        customersFullData: "/customers/all/full_data/",
        count: "/customers/count",
        customer: (customerId) => `/customers/${customerId}/`,
        reasons: "/customers/reasons/",
        statuses: "/customers/statuses/",
        customerAnonymization: "customers/customer/anonymization/",
        customerSymfoniaCode: "/customers/symfonia_code/",
        customerSymfoniaCodeUpdate: (customerId) => `/customers/symfonia_code/${customerId}/update/`,
        channels: {
            all: "/customers/channels/all/",
        },
        clauses: {
            all: "/customers/clauses/all/",
            details: (clauseId) => `/customers/clauses/${clauseId}/details/`, 
            subscribe: "/customers/clauses/subscribe/",
            unsubscribe: "/customers/clauses/unsubscribe/",
        },
        company: "/customers/company/",
        companies: {
            shortAll: "/customers/companies/short-all/",
            edit: (customerId) => `/customers/company/${customerId}/`,
            mails: (companyId) => `/customers/company/${companyId}/mails/`,
            updateAdditionalMails: (companyId) => `/customers/company/${companyId}/update_additional_mails/`,
            phones: (companyId) => `/customers/company/${companyId}/phones/`,
            updateAdditionalPhones: (companyId) => `/customers/company/${companyId}/update_additional_phones/`,
        },
        files: (customerId) => `/customers/${customerId}/files`,
        person: "/customers/person/",
        personIndex: "/customers/person-index/",
        personCompany: "/customers/person-company/",
        personCompanyDelete: (id) => `/customers/person-company/${id}/delete/`,
        personClause: "/customers/person-clause/",
        personSelectList: "/customers/person/select-list/",
        persons: {
            edit: (customerId) => `/customers/person/${customerId}/`,
            clauses: (personId) => `/customers/persons/${personId}/clauses`,
            detail: (personId) => `/customers/person/detail/${personId}`,
            update: (personId) => `/customers/person-index/update/${personId}/`,
            identificationDocuments: {
                list: (personId) => `/customers/person/${personId}/identification-documents/`,
                detail: (personId, documentId) =>
                    `/customers/person/${personId}/identification-documents/${documentId}/`,
            },
            mails: (personId) => `/customers/person/${personId}/mails/`,
            updateAdditionalMails: (personId) => `/customers/person/${personId}/update_additional_mails/`,
            phones: (personId) => `/customers/person/${personId}/phones/`,
            updateAdditionalPhones: (personId) => `/customers/person/${personId}/update_additional_phones/`,
        },

        deleteFromCustomer: "/files/customer/delete/",
        listCustomerDocuments: (customerId) => `/files/customer/${customerId}/list/`,
    },
    files: {
        file: (fileId) => `/files/${fileId}/`,
        getUploadToken: "/files/get_upload_token/",
        massAction: "files/mass_actions/",

        uploadToken: "/files/home/upload-token/",
        massActionHome: "/files/home/mass-action/",
        details: "/files/home/document-details/",
        download: "/files/home/document-download/",
        generateDocumentNumber: "/files/document-number/",

        connectToCustomer: "/files/customer/connect/",
        connectToProduct: "/files/product/connect/",
        connectToAgreement: "/files/agreement/connect/",
        connectToChannel: "/files/channel/connect/",

        listAllProductDocuments: "/files/documents/products/all/",
        updateDocumentProducts: "/files/document/update-products/",
        docsFilteringData: "/files/home/docs/filtering-data/",
        deleteAllFromProduct: "/files/product/delete-all/",
        listAllInvestmentDocuments: "/files/documents/invests/all/",
        updateDocumentInvests: "/files/document/update-invests/",
        deleteAllFromInvest: "/files/invest/delete-all/",
    },
    documents: {
        listDocumentProducts: (documentId) => `/document/${documentId}/list-products/`,
        download: (documentId) => `files/home/document/${documentId}/download/`,
        details: (documentId) => `files/home/docs/${documentId}/`,
        revisionHistory: (documentId) => `files/home/docs/${documentId}/revision_history/`,
        preview: (documentId) => `files/home/document/${documentId}/preview/`,
        update: (documentId) => `/files/home/docs/${documentId}/update/`,
    },
    filters: {
        filters: "filters/",
        filter: (filterId) => `filters/${filterId}/`,
    },
    products: {
        all: "/products/all",
        apartments: "/products/apartments",
        adjacent: "/products/adjacent",
        count: "/products/count",
        update: (productId) => `/products/${productId}/`,
        publishLastProductPricing: (productId) => `/products/${productId}/publish_last_pricing/`,
        delete: (productId) => `/products/${productId}/`,
        bookedDays: "/products/booked-days/",
        types: {
            list: "/products/types/",
            create: "/products/types/",
            delete: (typeId) => `/products/types/${typeId}/`,
        },
        statuses: "/products/statuses",
        kinds: "/products/kinds",
        massUpdate: "/products/mass_update/",
        massUpdateXlsx: "/products/xlsx_mass_update/",
        tags: {
            all: "/products/tags",
            create: "/products/tags/create/",
        },
        deleteFromProduct: "/product/delete/",
        listProductDocuments: (productId) => `/files/product/${productId}/list/`,
        cardsProductDocuments: (productId) => `/files/product/${productId}/cards/`,
        pricing: "products/pricing/",
        pricingDetails: (pricingId) => `/products/pricing/${pricingId}/details/`,
        productsWithPricing: "products/with_pricing/",
        proposals: "products/proposals/",
        proposalFilteringData: "products/proposals/filtering_data/",
        proposalDetails: (proposalId) => `/products/proposals/${proposalId}/details/`,
        proposalCount: "products/proposals/count/",
        styleSelectList: "products/styles/select_list/"
    },
    investments: {
        all: "/investments/all",
        update: (investmentId) => `/investments/${investmentId}/`,
        selectList: "/investments/select_list",
    },
    sales: {
        contacts: {
            contacts: "/sales/contacts/",
            count: "sales/contacts/count",
            all: "/sales/contacts/all",
            channelReport: "/sales/contacts/channel_report/",
            subjects: "/sales/contacts/subjects",
            editContact: (contactId) => `/sales/contacts/${contactId}/update/`,
            forPerson: (personId) => `/sales/contacts/${personId}`,
        },
        editReason: `/sales/reasons/edit/`,
        leads: {
            url: "/sales/leads/",
            count: "/sales/leads/count",
            lead: (leadId) => `/sales/leads/${leadId}/`,
            getStatusesUrl: "/sales/leads/statuses/",
            getLeadFailureReasonsUrl: "/sales/leads/reasons/",
            deleteLeadUrl: (leadId) => `/sales/personleads/${leadId}/`,
            addSellerToLeadUrl: "/sales/lead-sellers/",
            correctLeadPersonUrl: "/sales/leads/correct-person/",
            importTemplateUrl: "/sales/leads/import-template/",
            exportFileUrl: "/sales/leads/export/",
            importFile: "/sales/leads/import/",
            chartDistribution: "/sales/leads/chart_distribution/",
            chartfilteringData: "/sales/leads/chart_filtering_data/",
            leadAggregation: "/sales/leads/lead_aggregation/",
        },
        persons: {
            persons: "/sales/persons/",
            person: (personId) => `/sales/persons/${personId}/`,
            count: "/sales/persons/count",
            removeReferency: "/sales/persons/remove-referency/",
            correctLeadPerson: "/sales/leads/correct-person/",
        },
        sellers: {
            all: "/sales/sellers/",
            detail: (sellerId) => `/sales/sellers/${sellerId}/`,
            create: "/sales/sellers/create/",
            delete: (sellerId) => `/sales/sellers/${sellerId}/delete/`,
            emailFooters: {
                create: (sellerId) => `/sales/sellers/${sellerId}/email-footers/`,
                detail: (footerId) => `/sales/email-footers/${footerId}/`,
            },
            byUserId: (userId) => `/sales/users/${userId}/seller/`,
        },
        channels: {
            all: "/customers/channels/details/all/",
            filteringData: "/customers/channels/filtering_data/",
            channel: (channelId) => `/customers/channels/${channelId}/details/`,
            update: (channelId) => `/customers/channels/${channelId}/update/`,
            listChannelDocuments: (channelId) => `/files/channel/${channelId}/list/`,
            listChannelDocuments: (channelId) => `/files/channel/${channelId}/list/`,
            deleteDocumentFromChannel: "/files/channel/delete/",
        },
    },
    tasks: {
        url: "/tasks/",
        count: (userId) => `/tasks/${userId}/count`,
        list: "/tasks/list/", // TODO: refactor to have this under /tasks/
        subjects: "/tasks/subjects/",
        ways: "/tasks/ways/",
        subSubjects: "/tasks/subsubjects/",
        statuses: "/tasks/statuses/",
        task: (taskId) => `/tasks/${taskId}/`,
        finalize: (taskId) => `/tasks/${taskId}/finalize/`,
    },
    users: {
        userPermissions: {
            all: "/users/user_permissions/",
            check: "/users/user_permissions/check/",
        },
        userPreferences: (pageName) => `/users/user_preferences/${pageName}/`,
        auth: {
            loginUrl: "/users/auth/login/",
            logoutUrl: "/users/auth/logout/",
            refreshTokenUrl: "/users/auth/refresh/",
        },
        aadAuth: {
            login: "/users/aad_auth/login/",
        },
        myHomeAuth: {
            login: "/users/my_home_auth/login/",
        },
        users: "/users/",
    },
    enclosureDownloadUrl: (fooId) => `enclosure_download_url/${fooId}/`,
    fileUploader: {
        updateToken: "file_uploader/upload_token/",
    },
    offers: {
        all: "/offers/",
        statuses: "/offers/statuses/",
        count: "/offers/count/",
        reasons: "/offers/reasons/",
        update: (offerId) => `/offers/${offerId}/update/`,
        setStatus: (offerId) => `/offers/${offerId}/set-status/`,
        send: (offerId) => `/offers/${offerId}/send/`,
        detail: (offerId) => `/offers/${offerId}/`,
        customer: (customerId) => `/offers/customer/${customerId}/`,
        product: (productId) => `/offers/product/${productId}/`,
    },
    drafts: {
        all: "/drafts/",
        generateMail: (draftId) => `/drafts/${draftId}/generate/mail/`,
        generateNotificationMail: (draftId) => `/drafts/${draftId}/generate/notification-mail/`,
        generateOffer: (draftId) => `/drafts/${draftId}/generate/offer/`,
        generateBlankOffer: (draftId) => `/drafts/${draftId}/generate/offer/blank/`,
        generateAgreement: (draftId) => `/drafts/${draftId}/generate/agreement/`,
        generateAgreementDocx: (draftId) => `/drafts/${draftId}/generate/agreement/docx/`,
        downloadDraft: (draftId) => `/drafts/${draftId}/download/`,
        update: (draftId) => `/drafts/${draftId}/`,
        delete: (draftId) => `/drafts/${draftId}/`,
    },
    bankings: {
        banks: "/bankings/banks/",
        bankDetails: (bankId) => `/bankings/banks/${bankId}/details/`,
        bankings: "/bankings/bankings/",
        bankingDetails: (bankingId) => `/bankings/bankings/${bankingId}/details/`,
        bankingFilteringData: `/bankings/bankings/filtering_data/`,
        importBankingFile: "/bankings/bankings/import/",
        transferInvestmentBills: "/bankings/transfers/investment_bills/",
        transferInvestmentForAgreementBills: (agrementId) => `/bankings/transfers/${agrementId}/investment_bills/`,
        transferInvestmentBillsFilteringData: "/bankings/transfers/investment_bills/filtering_data/",
        transferInvestmentBillMassCreate: (agreementId) => `/bankings/transfers/investment_bills/${agreementId}/mass_create/`,
        transferInvestmentBillReturnTransferForAgreement: (agreementId) => `/bankings/transfers/investment_bills/${agreementId}/return_transfers/`,
        transferIndividualBills: "/bankings/transfers/individual_bills/",
        transferIndividualBillsFilteringData: "/bankings/transfers/individual_bills/filtering_data/",
        importIndividualBillsFile: "/bankings/transfers/individual_bills/import/",
        transferIndividualBillDetails: (transferId) => `/bankings/transfers/individual_bills/${transferId}/details/`,
        invoices: "/bankings/invoices/",
        importInvoiceFile: "/bankings/invoices/import/",
        invoceDetails: (invoceId) => `/bankings/invoices/${invoceId}/details/`,
        invoiceIsBooked: "/bankings/invoices/change_invoice_is_booked/",
        invoiceMassDelete: "/bankings/invoices/mass_delete/",
        transferIsBooked: "/bankings/transfers/change_transfer_is_booked/",
        transferIsInvoiced: "/bankings/transfers/change_transfer_is_invoiced/"
    },
    mailSender: "/mail-sender/",
};
